"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VerificationSent = exports.NewForwardEmailForm = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _formik = require("formik");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _FormErrorMessage = _interopRequireDefault(require("../../../components/FormErrorMessage"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _Input = _interopRequireDefault(require("../../../components/Input"));
var NewForwardEmailContainer = function NewForwardEmailContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-6 py-8"
  }, children);
};
var _default = exports["default"] = NewForwardEmailContainer;
var Header = function Header(_ref2) {
  var title = _ref2.title,
    subTitle = _ref2.subTitle;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-3xl font-bold"
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs text-gray-light"
  }, subTitle));
};
var NewForwardEmailForm = exports.NewForwardEmailForm = function NewForwardEmailForm(_ref3) {
  var isLoading = _ref3.isLoading,
    _onSubmit = _ref3.onSubmit,
    onClose = _ref3.onClose,
    validator = _ref3.validator;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(Header, {
    title: t('settings.general.forwardingAccounts.newEmailModal.title'),
    subTitle: t('settings.general.forwardingAccounts.newEmailModal.description')
  }), /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      email: ''
    }
    // Async validation is not working
    // Refered from: https://github.com/jaredpalmer/formik/issues/1392
    ,
    validate: ( /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(values) {
        var errors, error;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              errors = {};
              _context.t0 = (0, _isFunction["default"])(validator);
              if (!_context.t0) {
                _context.next = 6;
                break;
              }
              _context.next = 5;
              return validator(values.email);
            case 5:
              _context.t0 = _context.sent;
            case 6:
              error = _context.t0;
              if (!error) {
                _context.next = 10;
                break;
              }
              errors = {
                email: error
              };
              throw errors;
            case 10:
              return _context.abrupt("return", errors);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }()),
    onSubmit: function onSubmit(values) {
      return _onSubmit(values.email);
    },
    render: function render(_ref5) {
      var handleSubmit = _ref5.handleSubmit,
        errors = _ref5.errors,
        dirty = _ref5.dirty;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-1 py-4"
      }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        name: "email",
        className: "w-full"
      }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
        name: "email"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        color: "secondary",
        className: "w-24 text-xs mr-4",
        onClick: onClose
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        className: "w-24 text-xs",
        disabled: !(0, _isEmpty["default"])(errors) || !dirty || isLoading,
        onClick: handleSubmit
      }, t('button.verify'))));
    }
  }));
};
var VerificationSent = exports.VerificationSent = function VerificationSent(_ref6) {
  var email = _ref6.email,
    onClose = _ref6.onClose;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement(Header, {
    title: t('settings.general.forwardingAccounts.verficationSent.title'),
    subTitle: /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "settings.general.forwardingAccounts.verficationSent.description"
    }, "A confirmation link has been sent to ", /*#__PURE__*/_react["default"].createElement("strong", null, {
      email: email
    }), ' ', "to verify permission")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-4"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    className: "w-24 text-xs",
    onClick: onClose
  }, t('button.okay'))));
};
//# sourceMappingURL=NewForwardEmailModal.js.map